export default __webpack_public_path__ + "static/media/product-13.b164cec2.webp";